import RestApiModel from "@/api/Model/RestApiModel";

class Auth extends RestApiModel {
  static getResourceEndpoint() {
    return '/companies';
  }

  /**
   *
   * @returns {*}
   */
  static connections() {
    return super.list({
      endpoint: '/auth/connections',
    })
  }
}

export default Auth;
